import { LocalizedParagraph } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { OrderedList, OrderedListItem } from '../../components/OrderedList';

const listItems = [
    {
        id: 'application',
        labelKey: TextKey.FinancialServicesCapitalApplication,
        descriptionKey: TextKey.FinancialServicesCapitalApplyInMinutesText,
    },
    {
        id: 'funds',
        labelKey: TextKey.FinancialServicesCapitalAccessToFunds,
        descriptionKey: TextKey.FinancialServicesCapitalAccessToFundsText,
    },
    {
        id: 'flatRate',
        labelKey: TextKey.FinancialServicesCapitalFlatRate,
        descriptionKey: TextKey.FinancialServicesCapitalEnjoyFlexibleRepayments,
    },
    {
        id: 'yourWay',
        labelKey: TextKey.FinancialServicesCapitalUseItYourWay,
        descriptionKey: TextKey.FinancialServicesCapitalThereAreNoRules,
    },
];

export const BenefitsList = () => (
    <OrderedList>
        {listItems.map(({ labelKey, descriptionKey, id }, idx) => (
            <OrderedListItem key={id} labelKey={labelKey} idx={idx}>
                <LocalizedParagraph textKey={descriptionKey} />
            </OrderedListItem>
        ))}
    </OrderedList>
);
